import * as types from './mutation-types'

export default {
  [types.LOAD_PERIMETER_TYPES](state, data) {
    state.types = data.data
  },
}
